import { render, staticRenderFns } from "./resignationtable.vue?vue&type=template&id=bfabdb66"
import script from "./resignationtable.vue?vue&type=script&lang=js"
export * from "./resignationtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports